import * as React from "react";
import { useEffect } from "react";
import { useGetCountriesQuery } from "../../../api/rtk/CountryApi";
import { CountryViewModel } from "../../../model/CountryViewModel";
import { IBaseSelectProps } from "./IBaseSelectProps";
import { MultiLanguageSelect } from "./MultiLanguageSelect";

interface ICountrySelectProps extends IBaseSelectProps<string, string | undefined> {
  label: string;
  defaultValue?: string;
}

export const CountrySelect: React.FunctionComponent<ICountrySelectProps> = (props) => {
  const [countries, setCountries] = React.useState(new Array<CountryViewModel>());
  const { data: fetchedCountries } = useGetCountriesQuery();

  useEffect(() => {
    if (fetchedCountries !== undefined) {
      setCountries(fetchedCountries);
    }
  }, [fetchedCountries]);

  return <MultiLanguageSelect {...props} options={countries} />;
};
